export default __webpack_public_path__ + "static/media/pdf.c496abc1.png";